(function($) {
    $(function() {
        $("body").on("click", "#answers-submit", function (e) {
            e.preventDefault();
            var quizAnswers = [],
                nAnswers = 0,
                totalAnswers = 0,
                correctAnswers = 0;

            $(".quiz-container").find("input[type='radio']").each(function () {
                $this = $(this);
                $this.hasClass("ca") ? nAnswers++ : null;
                $this.is(":checked") ? totalAnswers++ : null;
                ($this.hasClass("ca") && $this.is(":checked")) ? correctAnswers++ : null;
                quizAnswers.push($this.is(":checked"));
            });
            
            if (totalAnswers === nAnswers) {
                sessionStorage.setItem("correctAnswers", correctAnswers);
                sessionStorage.setItem("quizAnswers", JSON.stringify(quizAnswers));
                $("#popup-form-quiz").show();
            } else {
                alert('Per proseguire è necessario completare il questionario');
            }
        });

        $("body").on("click", "#quiz-popup-close", function (e) {
            e.preventDefault();
            $("#popup-form-quiz").hide();
        });
    });
  })(jQuery);
  